var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSortBy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "filter"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93,43v15h162V43H93z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93,95.5v15h112.1v-15H93z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93,153v15h58.5v-15H93z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "keyboard-backspace"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "38.4,0 38.4,227.2 11.2,200 0.6,210.6 46,256 91.4,210.6 80.8,200 53.6,227.2 53.6,0  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSortBy);
export default __webpack_public_path__ + "static/media/icon-sort-by.0b22be9b.svg";
export { ForwardRef as ReactComponent };